import React, { useState, useEffect } from 'react'
import { Textarea, Button } from '@baseV2'
import { strings } from '@constants'
import { DescriptionPanel, DescriptionPanelActions } from './styles'

const DescriptionEditor = React.memo(function DescriptionEditor({ value, onSave, onCancel }) {
	const [draft, setDraft] = useState(value ?? '')

	// Re-sync whenever a different row's value is handed in, so reopening prefills correctly.
	useEffect(() => {
		setDraft(value ?? '')
	}, [value])

	return (
		<DescriptionPanel>
			<Textarea
				id='enquiry-item-message'
				autoFocus
				placeholder={strings('enter_message')}
				value={draft}
				onChange={(e) => setDraft(e.target.value)}
			/>
			<DescriptionPanelActions>
				<Button type='button' size='small' variant='outline' color='danger' onClick={onCancel}>
					{strings('cancel')}
				</Button>
				<Button type='button' size='small' color='primary' onClick={() => onSave(draft)}>
					{strings('save_message')}
				</Button>
			</DescriptionPanelActions>
		</DescriptionPanel>
	)
})

export default DescriptionEditor
